module.exports = __webpack_public_path__ + "img/guide-icon.349123af.svg";